const appInfo = {
  stage: "test",
  test: {
    shortName: "Outage Status Admin",
    longName: "Outage Status Admin App"
  }
};

export { appInfo };
